import { render, staticRenderFns } from "./NavBarAdmin.vue?vue&type=template&id=00525aa3"
import script from "./NavBarAdmin.vue?vue&type=script&lang=js"
export * from "./NavBarAdmin.vue?vue&type=script&lang=js"
import style0 from "./NavBarAdmin.vue?vue&type=style&index=0&id=00525aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports